import { Box, Stack, Typography } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { IDataItem } from "src/types/atoms";
import { InfoCircle } from "react-bootstrap-icons";
const TempData = ({
  label,
  value
}: IDataItem) => {
  return <Box flexBasis={230} marginBottom={2}>
      <Stack direction={"row"} spacing={1} marginBottom={1}>
        <Typography color={red[700]} fontWeight={700} marginBottom={1}>
          {label}
        </Typography>
        <InfoCircle color={red[700]} size="1.2rem" />
      </Stack>
      {typeof value === "string" ? <Typography color={grey[600]} fontWeight="bold">
          {value}
        </Typography> : value}
    </Box>;
};
export default TempData;